// angular.module('HeroPRO')
// 	.directive('filterBreadcrumbs',


export default function FilterBreadcrumbsDirective() {
    return {
        restrict: 'E',
        templateUrl: 'app/pipeline/filterBreadcrumbs/filterBreadcrumbsTemplate.html',
        scope: {
            dataset: '=',
            removeFilter: '&',
            launchModal: '&',
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/pipeline/filterBreadcrumbs/filterBreadcrumbsDirective.js